import cloneDeep from 'lodash/cloneDeep'
import LocationGroupApi from '@/api/LocationGroupApi/LocationGroupApi'
import LocationApi from '@/api/LocationApi/LocationApi'
import { locationGroupType as LocationGroupType } from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/constants'

const addProps = pointList => {
  const clonePointList = cloneDeep(pointList)
  clonePointList.forEach(point => {
    point.newItem = {
      id: null,
      new: false,
    }
    point.toDelete = false
  })
  return clonePointList
}

class LocationGroupOperation {
  static async getGroupList(
    ownerProfileId,
    locationGroupType = LocationGroupType.ALL,
  ) {
    const res = await LocationGroupApi.fetchLocationGroupList(
      ownerProfileId,
      locationGroupType,
    )
    return res.items
  }
  static async editLocationGroup({ locationGroupId, name, accessibleType }) {
    try {
      return await LocationGroupApi.editLocationGroup({
        locationGroupId,
        name,
        accessibleType,
      })
    } catch (e) {
      throw Error(e)
    }
  }
  static async putLocations({ locationGroupId, locationGroupType, locations }) {
    return LocationApi.putLocations({
      locationGroupId,
      locationGroupType,
      locations,
    })
  }
  static async getLocationList(locationGroupId, locationGroupType) {
    const res = await LocationApi.fetchLocationList(
      locationGroupId,
      locationGroupType,
    )
    const items = res.items
    return addProps(items)
  }
  static async addLocationGroup({
    ownerProfileId,
    locationGroupType,
    name,
    accessibleType,
  }) {
    try {
      return await LocationGroupApi.addLocationGroup({
        ownerProfileId,
        locationGroupType,
        name,
        accessibleType,
      })
    } catch (e) {
      throw Error(e)
    }
  }

  static get validations() {
    return {
      required: value =>
        Boolean(value !== undefined && value !== '') || '入力して下さい',
    }
  }
}

export default LocationGroupOperation
